"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var CoachClient = /*#__PURE__*/function () {
  function CoachClient(client) {
    (0, _classCallCheck2["default"])(this, CoachClient);
    this.client = client;
    this.resourceUrl = '/client';
  }

  (0, _createClass2["default"])(CoachClient, [{
    key: "getSearchUser",
    value: function getSearchUser(searchWord) {
      var _this$client;

      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var query = new URLSearchParams(queryParams).toString();
      var url = "".concat(this.resourceUrl, "/search/").concat(searchWord).concat(query ? "?".concat(query) : '');

      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return (_this$client = this.client).get.apply(_this$client, [url].concat(args));
    }
  }, {
    key: "getClientSpecificData",
    value: function getClientSpecificData(clientId, data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(clientId, "/selected-keys"), data, args);
    }
  }, {
    key: "updateEmail",
    value: function updateEmail(userId, data) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      return this.client.put("/user/".concat(userId, "/update-email"), data, args);
    }
  }, {
    key: "updateName",
    value: function updateName(userId, data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      return this.client.put("/user/".concat(userId, "/update-info"), data, args);
    }
  }]);
  return CoachClient;
}();

exports["default"] = CoachClient;